import { getField } from 'vuex-map-fields';
export default {
    getField,
    getPurchaseOption: state => id => {
        if (
            typeof state.user.profile.enrolment_purchase_option ==
                'undefined' ||
            state.user.profile.enrolment_purchase_option === null ||
            !state.user.profile.enrolment_purchase_option.length
        ) {
            return false;
        }
        let purchaseOptionId =
            id || state.user.profile.enrolment_purchase_option;

        return state.subscriptions.pricing[purchaseOptionId];
    },
    accepted_terms: state => {
        return state.user.accepted_terms;
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/Enrolment/getters.js